<template>
  <div
    class="unlink-offer-popup"
  >
    <div class="popup">
      <div class="head">
        <span class="name">{{ $t('affiliates.offersCategory.delete_catalog_title') }}</span>
        <UiIcon
          :size="19"
          class="close"
          name="times"
          @click="close"
        />
      </div>
      <div
        v-loading="isDataLoading"
        class="form"
      >
        <div class="row">
          <span class="text-top">{{ $t('affiliates.offersCategory.delete_catalog_msg') }}</span>
        </div>
        <div class="row">
          <div class="field">
            <UiSelectElement
              v-model="catalogId"
              class="t:mb-16"
              :placeholder="$t('affiliates.offersCategory.select_catalog')"
              :label="$t('affiliates.offersCategory.new_catalog')"
              :list="catalogs"
              size="big"
              required
              filterable
              label-bold
              width="200"
            />
          </div>
        </div>
      </div>

      <div class="foot t:space-x-8">
        <UiButton
          type="negative"
          size="big"
          icon="times"
          @click="close"
        >
          {{ $t('crm.buttons.cancel') }}
        </UiButton>
        <UiButton
          :disabled="!catalogId"
          size="big"
          filled
          icon="check"
          @click="confirmDelete"
        >
          {{ $t('affiliates.delete_offer.confirm') }}
        </UiButton>
      </div>
    </div>
    <div class="wrapper" />
  </div>
</template>

<script>
export default {
  name: 'CatalogDeleteConfirm',
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close', 'confirm'],
  data() {
    return {
      isDataLoading: false,
      catalogId: null,
      catalogs: [],
    };
  },

  watch: {
    isOpen(val) {
      if (val) {
        this.resetForm();
        this.getCatalogOptions();
      }
    },
  },

  mounted() {
    window.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  },

  methods: {
    resetForm() {
      this.catalogId = null;
      this.catalogs = [];
    },

    getCatalogOptions() {
      this.isDataLoading = true;

      this.$api
        .getAffiliateOffersCatalog()
        .then((res) => {
          this.catalogs = res.data.payload.filter((catalog) => catalog.id !== this.data.id);
        })
        .finally(() => {
          this.isDataLoading = false;
        });
    },

    confirmDelete() {
      if (!this.catalogId) return;

      this.$emit('confirm', this.catalogId);
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.unlink-offer-popup {
  .popup {
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
